import { GET_SITEMAP } from '@package/constants/ActionTypes';

/**
 * Get navigation.
 * @function getSitemap
 * @param {string} url Content url.
 * @param {number} depth Depth of the navigation tree.
 * @returns {Object} Get navigation action.
 */
export function getSitemap(url, depth) {
  // Note: Depth can't be 0 in plone.restapi
  return {
    type: GET_SITEMAP,
    request: {
      op: 'get',
      path: `${url}/@navigation${
        depth ? `?expand.navigation.depth=${depth}` : ''
      }`,
    },
  };
}
